import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { handleConnectionDetailChange } from '../../../utils';

interface SnowflakeFieldsProps {
  isEditable: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string) => void;
  onValidityChange: (isValid: boolean) => void;
}

// const SNOWFLAKE_USERNAME_REGEX = /^[a-zA-Z0-9_]+$/;
// const SNOWFLAKE_PASSWORD_REGEX = /^[a-zA-Z0-9_]+$/;
// const SNOWFLAKE_HOST_REGEX =
//   /^[a-zA-Z0-9-]+\.east-us\.snowflakecomputing\.com$/;
// const SNOWFLAKE_ROLE_REGEX = /^[a-zA-Z0-9_]+$/;
// const SNOWFLAKE_WAREHOUSE_REGEX = /^[a-zA-Z0-9_]+$/;
// const SNOWFLAKE_DATABASE_NAME_REGEX = /^[a-zA-Z0-9_]+$/;
// const SNOWFLAKE_SCHEMA_REGEX = /^[a-zA-Z0-9_]+$/;

const SnowflakeFields: React.FC<SnowflakeFieldsProps> = ({
  isEditable,
  formValues,
  handleInputChange,
  onValidityChange,
}) => {
  const connectionDetails = JSON.parse((formValues.connectionDetails as string) || '{}');

  const [isTouched, setIsTouched] = useState({
    username: false,
    password: false,
    host: false,
    role: false,
    warehouse: false,
    databaseName: false,
    schema: false,
  });

  useEffect(() => {
    const isUsernameValid = !!connectionDetails.username;
    const isPasswordValid = !!connectionDetails.password;
    const isHostValid = !!connectionDetails.host;
    const isRoleValid = !!connectionDetails.role;
    const isWarehouseValid = !!connectionDetails.warehouse;
    const isDatabaseNameValid = !!connectionDetails.databaseName;
    const isSchemaValid = !!connectionDetails.schema;

    const isAllValid =
      isUsernameValid &&
      isPasswordValid &&
      isHostValid &&
      isRoleValid &&
      isWarehouseValid &&
      isDatabaseNameValid &&
      isSchemaValid;
    onValidityChange?.(isAllValid);
  }, [
    connectionDetails.username,
    connectionDetails.password,
    connectionDetails.host,
    connectionDetails.role,
    connectionDetails.warehouse,
    connectionDetails.databaseName,
    connectionDetails.schema,
  ]);

  return (
    <>
      <TextField
        label="Username"
        placeholder="e.g. pvx_read_only_user"
        value={connectionDetails.username}
        error={!connectionDetails.username && isTouched.username}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            username: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('username', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Password"
        placeholder="Read-only user password"
        value={connectionDetails.password}
        error={!connectionDetails.password && isTouched.password}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            password: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('password', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Host"
        placeholder="e.g. xy12345.east-us.snowflakecomputing.com"
        value={connectionDetails.host}
        error={!connectionDetails.host && isTouched.host}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            host: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('host', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Role"
        placeholder="e.g. READ_ONLY_ROLE"
        value={connectionDetails.role}
        error={!connectionDetails.role && isTouched.role}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            role: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('role', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Warehouse"
        placeholder="e.g. COMPUTE_WH"
        value={connectionDetails.warehouse}
        error={!connectionDetails.warehouse && isTouched.warehouse}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            warehouse: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('warehouse', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Database Name"
        placeholder="e.g. PVX_DB"
        value={connectionDetails.databaseName}
        error={!connectionDetails.databaseName && isTouched.databaseName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            databaseName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'databaseName',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="Schema"
        placeholder="e.g. PUBLIC"
        value={connectionDetails.schema}
        error={!connectionDetails.schema && isTouched.schema}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            schema: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('schema', e.target.value, formValues, handleInputChange)
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
    </>
  );
};

export default SnowflakeFields;
